module.exports = __webpack_public_path__ + "img/boîte de nuit.e193594b.png";